import { Routes } from '@angular/router';

import { UserRole } from '@/app/api/users';

import { authGuard, guestGuard, userRoleGuard, permissionGuard, profileResolverGuard } from '@/app/core/guards';

import { AuthLayoutComponent } from '@/app/core/layouts/auth-layout';
import { MainLayoutComponent } from '@/app/core/layouts/main-layout';

export const AppRoutes: Routes = [
  {
    path: 'auth',
    canMatch: [guestGuard],
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        loadComponent: () => import('@/app/pages/auth/login/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'two-factor',
        loadComponent: () =>
          import('@/app/pages/auth/two-factor/two-factor.component').then((m) => m.TwoFactorComponent),
      },
    ],
  },
  {
    path: '',
    canMatch: [authGuard, profileResolverGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'clients',
      },
      {
        path: 'clients',
        canMatch: [permissionGuard('view_clients')],
        loadComponent: () =>
          import('@/app/pages/clients-list/clients-list.component').then((m) => m.ClientsListComponent),
      },
      {
        path: 'clients/incomplete-subscriptions',
        canMatch: [userRoleGuard([UserRole.SuperAdmin, UserRole.Admin, UserRole.Manager])],
        loadComponent: () =>
          import('@/app/pages/incomplete-subscriptions/incomplete-subscriptions.component').then(
            (m) => m.IncompleteSubscriptionsComponent,
          ),
      },
      {
        path: 'clients/:id',
        canMatch: [permissionGuard('view_client')],
        loadComponent: () =>
          import('@/app/pages/client-detail/client-detail.component').then((m) => m.ClientDetailComponent),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'transactions',
          },
          {
            path: 'transactions',
            canMatch: [permissionGuard('view_transactions')],
            loadComponent: () =>
              import('@/app/pages/client-detail/pages/client-transactions/client-transactions.component').then(
                (m) => m.ClientTransactionsComponent,
              ),
          },
          {
            path: 'accounts',
            canMatch: [permissionGuard('view_accounts')],
            loadComponent: () =>
              import('@/app/pages/client-detail/pages/client-accounts/client-accounts.component').then(
                (m) => m.ClientAccountsComponent,
              ),
          },
        ],
      },
      {
        path: 'team-management',
        canMatch: [permissionGuard('view_users')],
        loadComponent: () =>
          import('@/app/pages/team-management/team-management.component').then((m) => m.TeamManagementComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
